import api from '@/api/clients/api';
import { OrganizationAdmin } from '@/features/organization-admins/api/types/organization-admin';

class OrganizationAdminsApi {
  async fetchOrganizationAdmins(): Promise<OrganizationAdmin[]> {
    const { data } = await api.get<OrganizationAdmin[]>(`/admins`);

    return data;
  }

  async removeAdminFromOrganization(adminId: number): Promise<void> {
    const { data } = await api.delete(`/admins/${adminId}`);

    return data;
  }

  async inviteNewOrganizationAdmin(
    email: string,
    isOwner: boolean,
    friendlyName: string,
  ): Promise<OrganizationAdmin> {
    const { data } = await api.post<OrganizationAdmin>(`/admins`, {
      email,
      isOwner,
      friendlyName,
    });

    return data;
  }

  async fetchUserInfo(): Promise<OrganizationAdmin> {
    const { data } = await api.get<OrganizationAdmin>(`/profile`);

    return data;
  }
}

export const organizationAdminsApi = new OrganizationAdminsApi();
